import { render, staticRenderFns } from "./subNavItem.vue?vue&type=template&id=175328a4&scoped=true&"
import script from "./subNavItem.vue?vue&type=script&lang=js&"
export * from "./subNavItem.vue?vue&type=script&lang=js&"
import style0 from "./subNavItem.vue?vue&type=style&index=0&id=175328a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175328a4",
  null
  
)

export default component.exports